import React from 'react';
import ArticlePage from '../../platformui/Pages/article';
import * as Render from '../../platformui/Base/Render';
import ChapterBlock from '../../blocks/chapter-block';
import ChapterContainerBlock from '../../blocks/chapter-container-block';
import ImageBlock from '../../blocks/image-block';
import VideoBlock from '../../blocks/video-block';
import LinkCollectionBlock from '../../blocks/linklist-block';
import ReferenceListBlock from '../../blocks/referencelist-block';
import HighlightBlock from '../../blocks/highlight-block';
import SlideshowBlock from '../../blocks/slideshow-block';
import EpiserverFormsBlock from '../../blocks/episerver-forms-block';
import AnchorNav from '../../components/anchor-nav';
import withAnchorNav from '../../platformui/Containers/withAnchorNav';
import ActionTableBlock from '../../blocks/action-table-block';
import ListContainerBlock from '../../blocks/list-container-block';
import SearchLinkListBlock from '../../blocks/search-link-list-block';
import RegionalizationBlock from '../../blocks/regionalization-block';
import ManuelPageListBlock from '../../blocks/manuel-page-list-block';
import SelfTestQuestionBlock from '../../blocks/self-test-block';
import ContentHistoryBlock from '../../blocks/content-history-block';
import SurveyBlock from '../../blocks/survey-block';
import TableBlock from '../../blocks/table-block';
import MatomoTrackDataAttribute from '../../platformui/Matomo/matomo-track-data-attribute';

const Blocks = {
  ImageBlock,
  ChapterBlock,
  ChapterContainerBlock,
  VideoBlock,
  LinkCollectionBlock,
  ReferenceListBlock,
  HighlightBlock,
  SlideshowBlock,
  EpiserverFormsBlock,
  ActionTableBlock,
  ListContainerBlock,
  SearchLinkListBlock,
  RegionalizationBlock,
  ManuelPageListBlock,
  SelfTestQuestionBlock,
  ContentHistoryBlock,
  SurveyBlock,
  TableBlock,
};

const blockTypes = <Render.BlockTypeRenderer Blocks={Blocks} />;

const ArticlePageRhbVhb = (props) => {
  return (
    <>
      <ArticlePage
        {...props}
        BlockTypeRenderer={blockTypes}
        SubjectAboveHeading={true}
        RightColumnComponents={
          !props.Content.HideAnchorNavigation && (
            <AnchorNav
              Links={props.Content.AnchorNavigation}
              anchorHeading={props.Content.Translations.anchorheading}
              currentActiveMenuItem={(id) => props.currentActiveMenuItem(id)}
              currentActiveId={props.currentActiveId}
            />
          )
        }
      />
      <MatomoTrackDataAttribute />
    </>
  );
};

export default withAnchorNav(ArticlePageRhbVhb);
